import { AGENT_C, AGENT_L } from './agentColor'

/**
 * A PERSON'S FALLBACK AVATAR — owner, 2026-09-13: 使用 Apple account 登入的使用者都沒有
 * 頭像; 先用替代方案: 一個圓圈圈, 給一個隨機的背景圖案, 上面放上使用者 email 的首字字母.
 *
 * "Random" has to mean STABLE: the background is derived from the address, so the
 * same person is the same colours on every surface and every visit — a colour that
 * changed per render would read as a different person. FNV-1a over the lowercased
 * address picks the hue; the lightness and chroma are the agents' (agentColor.ts),
 * so people and agents read as one system. Two neighbouring hues in a diagonal
 * gradient are the "pattern": more than a flat disc, less than a picture.
 *
 * The letter is the FIRST of the EMAIL, never of a display name: a name is optional
 * (Apple hands one over once, and only if asked) and can change; the address is the
 * identity the app keys on. A label is the fallback only where no address is known.
 */
function fnv1a(s: string): number {
  let h = 0x811c9dc5
  for (const ch of s) {
    h ^= ch.codePointAt(0)!
    h = Math.imul(h, 0x01000193) >>> 0
  }
  return h >>> 0
}

function personHue(seed: string): number {
  return fnv1a(seed.trim().toLowerCase()) % 360
}

/** The circle's background: a two-hue gradient, the same for this address forever. */
export function personBackground(seed: string): string {
  const h = personHue(seed)
  const h2 = (h + 40) % 360
  return `linear-gradient(135deg, oklch(${AGENT_L} ${AGENT_C} ${h}), oklch(${AGENT_L} ${AGENT_C} ${h2}))`
}

/** The letter on the circle: the email's first, else the label's, else `?`. */
export function personLetter(email: string | null | undefined, label?: string | null): string {
  const src = email?.trim() || label?.trim() || ''
  // Code-point aware, so a leading emoji is the whole glyph, not half a surrogate pair.
  const first = [...src][0]
  return first ? first.toUpperCase() : '?'
}
